import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { cn } from '@/shadcn-ui/utils';
import { getDynamicCurrency } from '@/util-conversion/currency';

interface SavingsGradientTextProps extends ComponentPropsWithoutRef<'p'> {
  savingsNumber: number;
  savingsSuffix?: string;
  variant?: 'small' | 'default';
}

const SavingsGradientText = forwardRef<HTMLParagraphElement, SavingsGradientTextProps>(
  (
    {
      savingsNumber,
      variant = 'default',
      savingsSuffix,
      className,
      ...props
    }: SavingsGradientTextProps,
    ref
  ) => {
    return (
      <p
        ref={ref}
        className={cn(
          'body-strong bg-gradient-to-r from-[#00FFCD] from-[-45.4%] to-[#2A00A5] to-[100%] bg-clip-text text-transparent',
          {
            'text-[14px] leading-[20px]': variant === 'small',
          },
          className
        )}
        {...props}
      >
        {getDynamicCurrency(savingsNumber)}
        {savingsSuffix ?? ''}
      </p>
    );
  }
);

SavingsGradientText.displayName = 'SavingsGradientText';

export default SavingsGradientText;
